import API from '@/service/hub-api';
import Store from '@/store';
import PathUtils from '@/utils/path';

const FACILITATOR_PORTAL_SESSION_API = '/facilitator-portal/sessions';

export default {
  parseLoginUser(token) {
    const [, payloadTokenPart] = token.split('.');
    const fullPayloadData = JSON.parse(window.atob(payloadTokenPart));
    return (({ iat, exp, ...payloadData }) => payloadData)(fullPayloadData);
  },

  async loadStoredSession() {
    const storedToken = localStorage.getItem('hub-facilitator-portal-token');

    if (!storedToken) {
      await Store.dispatch('clearSession');
      return;
    }

    const storedSettings = localStorage.getItem('hub-facilitator-portal-settings');

    await Store.dispatch('createSession', {
      token: storedToken,
      loginUser: this.parseLoginUser(storedToken),
      settings: storedSettings ? JSON.parse(storedSettings) : {},
    });
  },

  /**
   * Validates the currently stored session in the vuex store
   */
  async validateSession() {
    if (!Store.getters.token) {
      return false;
    }

    try {
      const result = await API.get(FACILITATOR_PORTAL_SESSION_API, { jwt: true });
      return result.success;
    } catch (error) {
      return false;
    }
  },

  async login(email, password, backward) {
    const result = await API.post(FACILITATOR_PORTAL_SESSION_API, { email, password, jwt: true });
    const { newToken } = result;

    if (!newToken) {
      throw new Error('Login info is incorrect.');
    }

    await Store.dispatch('updateAuthToken', { newToken });
    window.location.replace(PathUtils.resolve('app').url + (backward || ''));
  },

  async logout() {
    await Store.dispatch('clearSession');
    window.location.replace(PathUtils.resolve('app').url);
  },
};
